export const hasAccountIdentity = (
  id: number | null | undefined,
  name: string | null | undefined,
  axNumber: string | null | undefined,
) => Boolean(id || axNumber || name?.trim());
